import { Box, CircularProgress } from "@mui/material";

export default function LoadingCircular() {
    return <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
        <CircularProgress sx={{ mt: 1, mb: 3, }} />
    </Box>
}